import React, { useState } from 'react'
import { ReactComponent as CopyIcon } from '@/assets/icons/copy.svg'
import { copyTextToClipboard } from '@knots/shared-frontend'
import Typography from '@/components/ui/Typography'
import classes from './CopyAdornment.module.scss'
import clsx from 'clsx'

export type CopyAdornmentProps = {
  value: string
}

const CopyAdornment = ({ value }: CopyAdornmentProps) => {
  const [isActive, setIsActive] = useState(false)
  const handleClick = async () => {
    setIsActive(true)
    await copyTextToClipboard(value)

    setTimeout(() => {
      setIsActive(false)
    }, 2000)
  }

  const className = clsx(classes.root, {
    [classes.active]: isActive,
  })

  return (
    <div role="presentation" className={className} onClick={handleClick}>
      <CopyIcon />
      <Typography isBold>{isActive ? 'Copied' : 'Copy'}</Typography>
    </div>
  )
}

export default CopyAdornment
